var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: self-end;\n\n  @media(max-width: 991.98px) {\n    margin-bottom: 20px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: self-end;\n\n  @media(max-width: 991.98px) {\n    margin-bottom: 20px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-bottom: none;\n  position: absolute;\n  right: 10px;\n  z-index: 10;\n'], ['\n  border-bottom: none;\n  position: absolute;\n  right: 10px;\n  z-index: 10;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n'], ['\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n  margin-bottom: 1rem;\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n  margin-bottom: 1rem;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 20px;\n'], ['\n  font-size: 20px;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['', ''], ['', '']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  ', '\n'], ['\n  color: ', ';\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: 14px;\n  line-height: 8px;\n  display: block;\n'], ['\n  font-family: ', ';\n  font-size: 14px;\n  line-height: 8px;\n  display: block;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  padding: 3rem;\n  height: 100%;\n  background-color: #E9EBEE;\n  border-left: 1px solid #B4BDCC;\n  text-align: center;\n'], ['\n  padding: 3rem;\n  height: 100%;\n  background-color: #E9EBEE;\n  border-left: 1px solid #B4BDCC;\n  text-align: center;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Modal as RSModal, ModalHeader as RSModalHeader, Row, Col } from 'reactstrap';
import Theme from '../../Theme';
import { Button } from '../Dashboard';
import Checkbox from '../FormikFormHelpers/Checkbox';
import { GOOGLE_LOGIN_LINK } from './handleMailClick';
import getPgaTld from '../../getPgaTld';

import './modal.css';

var FlexColumn = styled(Col)(_templateObject);
var ModalHeader = styled(RSModalHeader)(_templateObject2);
export var Modal = styled(RSModal)(_templateObject3);

var Title = styled.h4(_templateObject4, Theme.colors.primary, Theme.fonts.PlayfairDisplay);
var Header = styled(Title)(_templateObject5);

var baseParagraphStyles = '\n  color: ' + Theme.colors.primary + ';\n  font-family: ' + Theme.fonts.Montserrat + ';\n  font-size: 14px;\n  line-height: 21px;\n  margin-bottom: 1rem;\n';

var Paragraph = styled.p(_templateObject6, baseParagraphStyles);

var ExternalLink = styled.a(_templateObject7, Theme.colors.lightBlue, baseParagraphStyles);

export var StyledButton = styled(Button)(_templateObject8, Theme.fonts.Montserrat);
var PaddingWrapper = styled.div(_templateObject9);

var SIGNUP_FORM_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSc2aRVfGf71mXvrq0lHIyIKUBjv5G6OmGr15wooftY7fU38cw/viewform';

var pgaTld = getPgaTld();

export var LoginContent = function LoginContent(_ref) {
  var tempPassword = _ref.meEmailMigrationData.tempPassword,
      onToggleDoNotShowAgain = _ref.onToggleDoNotShowAgain;

  var goLogin = function goLogin() {
    return window.location.assign(GOOGLE_LOGIN_LINK);
  };
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Title,
      null,
      'Your PGA.com email account is now in Gmail!'
    ),
    React.createElement(
      Paragraph,
      { className: 'text-left' },
      'Your account has been moved to Gmail as part of our effort to bring members a more secure email solution. If you haven\u2019t logged in yet, use the temporary password provided. You\u2019ll be prompted to update it before you get started.'
    ),
    React.createElement(
      Row,
      { className: 'text-left mt-4' },
      React.createElement(
        FlexColumn,
        { lg: '6', md: '12' },
        React.createElement(
          Header,
          null,
          'I\'ve already reset my password.'
        ),
        React.createElement(
          Paragraph,
          null,
          'Great! If you want to bypass this message in the future and go right to your login, check the box below.'
        ),
        React.createElement(
          'div',
          { className: 'my-3' },
          React.createElement(Checkbox, { darker: true, label: 'Don\u2019t show this again.', fontSize: '15px', field: { onChange: onToggleDoNotShowAgain } })
        ),
        React.createElement(
          StyledButton,
          { onClick: goLogin },
          'Login'
        )
      ),
      React.createElement(
        FlexColumn,
        { lg: '6', md: '12' },
        React.createElement(
          Header,
          null,
          'I haven\'t logged in yet.'
        ),
        React.createElement(
          Paragraph,
          null,
          'The first time you access your account, you\u2019ll need to use the temporary password below. You\u2019ll be prompted to update it as soon as you login.'
        ),
        tempPassword && React.createElement(
          Paragraph,
          null,
          React.createElement(
            'strong',
            null,
            'Temporary Password: ',
            tempPassword
          )
        ),
        React.createElement(
          StyledButton,
          { onClick: goLogin },
          'Login'
        )
      )
    ),
    React.createElement(
      'div',
      { className: 'mt-4 text-left' },
      React.createElement(
        Paragraph,
        null,
        'To access the current email system before you\'re fully migrated to Gmail, ',
        React.createElement(
          'a',
          { href: 'https://webmail.pgalinks.com', target: '_blank', rel: 'noopener noreferrer' },
          'click here.'
        )
      ),
      React.createElement(
        Paragraph,
        { className: 'mb-0' },
        'Need help? Visit the Gmail Resources page on ',
        React.createElement(
          'a',
          { href: 'https://www.' + pgaTld + '/gmail-resources', target: '_blank', rel: 'noopener noreferrer' },
          'PGA.org'
        )
      )
    )
  );
};

export var AllowedSignupContent = function AllowedSignupContent(_ref2) {
  var toggle = _ref2.toggle;

  var goSignup = function goSignup() {
    return window.location.assign(SIGNUP_FORM_LINK);
  };
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Title,
      null,
      'Signup for a PGA.com email address'
    ),
    React.createElement(
      Paragraph,
      { className: 'text-left' },
      'PGA of America offers free PGA.com email to Members in good standing. If you would like a PGA.com email address, please request one at the link below.'
    ),
    React.createElement(
      'div',
      { className: 'd-flex flex-column align-items-center mt-4' },
      React.createElement(
        StyledButton,
        { onClick: goSignup },
        'Signup'
      ),
      React.createElement(
        ExternalLink,
        { className: 'mt-2', onClick: toggle },
        'No thanks I\'ll do it later'
      )
    ),
    React.createElement(
      'div',
      { className: 'text-left' },
      React.createElement(
        Paragraph,
        null,
        'If you think you landed here by mistake, and you already have a PGA.com email account, please call Membership Services at ',
        React.createElement(
          'a',
          { href: 'tel:18004742776' },
          '1-800-474-2776'
        ),
        '.'
      )
    )
  );
};
export var NotAllowedSignupContent = function NotAllowedSignupContent(_ref3) {
  var toggle = _ref3.toggle;
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Title,
      null,
      'Signup for a PGA.com email address'
    ),
    React.createElement(
      Paragraph,
      { className: 'text-left' },
      'You must be a PGA Member, Student or Associate to be eligible for a PGA.com email account.'
    ),
    React.createElement(
      'div',
      { className: 'd-flex flex-column align-items-center mt-4' },
      React.createElement(
        StyledButton,
        { onClick: toggle },
        'Close window'
      )
    )
  );
};

export var SignupContent = function SignupContent(_ref4) {
  var toggle = _ref4.toggle,
      _ref4$me = _ref4.me,
      me = _ref4$me === undefined ? {} : _ref4$me;

  return ['MB', 'AP'].includes(me.type) ? React.createElement(AllowedSignupContent, { toggle: toggle }) : React.createElement(NotAllowedSignupContent, { toggle: toggle });
};

export default (function (_ref5) {
  var open = _ref5.open,
      onToggle = _ref5.onToggle,
      type = _ref5.type,
      meEmailMigrationData = _ref5.meEmailMigrationData,
      onToggleDoNotShowAgain = _ref5.onToggleDoNotShowAgain,
      me = _ref5.me;

  var toggle = function toggle() {
    return onToggle(false);
  };
  var passProps = {
    toggle: toggle,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain,
    me: me
  };
  return React.createElement(
    Modal,
    { isOpen: open, toggle: toggle, size: 'lg', centered: true },
    React.createElement(ModalHeader, { toggle: toggle }),
    React.createElement(
      Row,
      null,
      React.createElement(
        Col,
        { lg: '12' },
        React.createElement(
          PaddingWrapper,
          null,
          type === 'gmailLogin' ? React.createElement(LoginContent, passProps) : React.createElement(SignupContent, passProps)
        )
      )
    )
  );
});